import { BRAND_FAQ, BRAND_FAQS, BRAND_FAQS_ORDER } from '../constants/UriConstants';
import { BrandFaqInterface, BrandFaqRequest } from '../types/BrandFaqInterface';
import apiClient from './apiClient';

export const getBrandFaqs = (brandID: string): Promise<BrandFaqInterface[]> =>
  apiClient.get(BRAND_FAQS(brandID)).then((response) => response.data);

export const createBrandFaq = (brandID: string, faq: BrandFaqRequest): Promise<BrandFaqInterface> =>
  apiClient.post(BRAND_FAQS(brandID), faq).then((response) => response.data);

export const updateBrandFaq = (brandID: string, faqID: number, faq: BrandFaqRequest): Promise<BrandFaqInterface> =>
  apiClient.put(BRAND_FAQ(brandID, faqID), faq).then((response) => response.data);

export const deleteBrandFaq = (brandID: string, faqID: number): Promise<void> =>
  apiClient.delete(BRAND_FAQ(brandID, faqID)).then(() => undefined);

export const reorderBrandFaqs = (brandID: string, faqIDs: number[]): Promise<BrandFaqInterface[]> =>
  apiClient.put(BRAND_FAQS_ORDER(brandID), { faqIDs }).then((response) => response.data);
